
import { IUserHolidayPopup, EHoliday } from '@zunta/configurations'
import ApiInstance from './instance'

export default class UserHolidayPopupApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  saveUserHolidayPopup (data: Partial<IUserHolidayPopup>) {
    return this.instance.doPost('userHolidayPopup', data) as Promise<'OK'>
  }

  findUserHolidayPopup (userId: number, holiday: EHoliday, year: number) {
    return this.instance.doGet(`userHolidayPopup/${userId}`, { holiday, year }) as Promise<IUserHolidayPopup>
  }
}
